import type { Resource } from '../../';
export const general_errors_defaultFallback: Resource = {"default":"There was an issue displaying this content. Please try again later."};
